// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__Jw5HC","fullwidth":"styles_fullwidth__2vt6M"};